// Node Modules
import React from "react";
import { RouteData } from "react-static";

// Global Components
import Link from "components/link/link";

// Global Assets
import logo from "assets/images/logo.png";

// Local Components
import AboutNavigation from "./components/aboutNavigation/aboutNavigation";
import AboutUs from "./aboutUs/aboutUs";
import Contact from "./contact/contact";
import Press from "./press/press";
// import Projects from "./projects/projects";
import Sustainability from "./sustainability/sustainability";
import Terms from "./terms/terms";
import OrderingInfo from "./orderingInfo/orderingInfo";

// Local Styling
import "./about.css";
import "./about-mobile.css";

// diff
class About extends React.Component {
  render() {
    return (
      <div className="about">
        <div className="logo-container">
          <Link to="/">
            <img style={{ maxWidth: "100%" }} src={logo} />
          </Link>
        </div>
        <div className="contentContainer">
          <RouteData>
            {({ page }) => <AboutNavigation active={page.fields.title} />}
          </RouteData>
          <RouteData>
            {({ page, policies }) => {
              // return <div>{page.fields.title}</div>;
              //   check to see if title has corresponding component, fetch component and inject content
              // otherwise just return content
              switch (page.fields.title) {
                case "About Us":
                  return <AboutUs content={page.fields.content} />;
                case "Contact":
                  return <Contact content={page.fields.content} />;
                case "Press":
                  return <Press content={page.fields.content} />;
                case "Sustainability":
                  return <Sustainability content={page.fields.content} />;
                case "Terms":
                  return <Terms policies={policies} />;
                case "Ordering Info":
                  return (
                    <OrderingInfo
                      policies={policies}
                      content={page.fields.content}
                    />
                  );
                default:
                  return null;
              }
            }}
          </RouteData>
        </div>
      </div>
    );
  }
}
export default About;
